import { FaPix } from 'react-icons/fa6';
import { FaApple, FaBarcode, FaRegCreditCard, FaAmazonPay } from 'react-icons/fa';
import { SiGooglepay } from 'react-icons/si';
import React from 'react';
import * as S from './payment-methods-minimalist.style';
import { Checkout } from '../../../../../common/types/checkout';
import { MetodoPagamentoVendaEnum } from '../../../../../common/types/enums/metodo-pagamento.enum';
import { useTranslation } from 'react-i18next';
import { PaisMercadoGlobalEnum } from '../../../../../common/types/enums/pais-mercado-global.enum';

type Props = {
  checkout: Checkout;
  selectedMethod: MetodoPagamentoVendaEnum;
  setSelectedMethod: (pm: MetodoPagamentoVendaEnum) => void;
  applePay?: {
    available: boolean;
    onClick: () => void;
    loading: boolean;
  };
  googlePay?: {
    available: boolean;
    onClick: () => void;
    loading: boolean;
  };
};

export const PaymentMethodsMinimalist: React.FC<Props> = ({
  checkout,
  setSelectedMethod,
  selectedMethod,
  applePay,
  googlePay,
}) => {
  const { t } = useTranslation();
  return (
    <S.PaymentOptions>
      {/* PIX */}
      {checkout?.paisEnum === PaisMercadoGlobalEnum.BRA &&
        checkout?.metodosPagamento?.includes('pix') && (
          <S.PaymentOption
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
                ?.color
            }
            active={selectedMethod === MetodoPagamentoVendaEnum.PIX}
            onClick={() => setSelectedMethod(MetodoPagamentoVendaEnum.PIX)}
          >
            <S.IconWrapper size="32px">
              <FaPix />
            </S.IconWrapper>
            <span>{t('paymentMethodDescription.PIX')}</span>
          </S.PaymentOption>
        )}

      {/* CARTÃO */}
      {checkout?.metodosPagamento?.includes('cc') && (
        <S.PaymentOption
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
              ?.color
          }
          active={selectedMethod === MetodoPagamentoVendaEnum.CARTAO_CREDITO}
          onClick={() =>
            setSelectedMethod(MetodoPagamentoVendaEnum.CARTAO_CREDITO)
          }
        >
          <S.IconWrapper size="32px">
            <FaRegCreditCard />
          </S.IconWrapper>
          <span>{t('paymentMethodDescription.CARTAO_CREDITO')}</span>
        </S.PaymentOption>
      )}

      {checkout?.paisEnum === PaisMercadoGlobalEnum.BRA &&
        checkout?.metodosPagamento?.includes('boleto') && (
          <S.PaymentOption
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
                ?.color
            }
            active={selectedMethod === MetodoPagamentoVendaEnum.BOLETO}
            onClick={() => setSelectedMethod(MetodoPagamentoVendaEnum.BOLETO)}
          >
            <S.IconWrapper size="32px">
              <FaBarcode />
            </S.IconWrapper>
            <span>{t('paymentMethodDescription.BOLETO')}</span>
          </S.PaymentOption>
        )}

      {/* Google Pay */}
      {checkout?.metodosPagamento?.includes('googlepay') &&
        googlePay?.available && (
        <S.PaymentOption
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
              ?.color
          }
          active={selectedMethod === MetodoPagamentoVendaEnum.GOOGLE_PAY}
          onClick={() =>
            setSelectedMethod(MetodoPagamentoVendaEnum.GOOGLE_PAY)
          }
        >
          <S.IconWrapper size="32px">
            <SiGooglepay size={25} />
          </S.IconWrapper>
          <span>Google Pay</span>
        </S.PaymentOption>
      )}

      {checkout?.metodosPagamento?.includes('applepay') &&
        applePay?.available && (
          <S.PaymentOption
            color={
              checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
                ?.color
            }
            active={selectedMethod === MetodoPagamentoVendaEnum.APPLE_PAY}
            onClick={() =>
              setSelectedMethod(MetodoPagamentoVendaEnum.APPLE_PAY)
            }
          >
            <S.IconWrapper size="32px">
              <FaApple size={25} />
            </S.IconWrapper>
            <span>Apple Pay</span>
          </S.PaymentOption>
        )}

      {/* Amazon Pay removido — disponível apenas no checkout expresso */}
      {/* Amazon Pay */}
      {checkout?.metodosPagamento?.includes('amazonpay') && (
        <S.PaymentOption
          color={
            checkout?.checkoutConfig?.config?.checkoutData?.paymentMethods
              ?.color
          }
          active={selectedMethod === MetodoPagamentoVendaEnum.AMAZON_PAY}
          onClick={() =>
            setSelectedMethod(MetodoPagamentoVendaEnum.AMAZON_PAY)
          }
        >
          <S.IconWrapper size="32px">
            <FaAmazonPay size={25} />
          </S.IconWrapper>
          <span>Amazon Pay</span>
        </S.PaymentOption>
      )}
    </S.PaymentOptions>
  );
};
